<!-- [TRACKING-CONSENT] Confirmation du retrait du consentement à la mesure d'ouverture des emails -->
<template>
  <div class="relative mt-24">
    <p class="text-green font-bold w-fit m-4 mx-auto text-2xl text-center">
      Votre opposition a bien été prise en compte : nous n'utiliserons plus de pixel de suivi dans les emails que nous vous envoyons.
    </p>
    <p class="w-fit m-4 mx-auto text-center text-grey">
      Vous continuerez à recevoir nos emails comme d'habitude.
    </p>
  </div>
</template>

<script>
export default {
  name: 'TrackingOptoutView'
}
</script>

<style scoped></style>
